// Patch OptionsSelection element of retina.js to correctly hide non-existant variants
// Requires that this file be parsed *after* retina.js
customElements.whenDefined('options-selection').then(() => {
  const OptionsSelection = customElements.get('options-selection');
  const originalUpdateOptions = OptionsSelection.prototype._updateOptions;

  function findNearestVariant(product, computedSelected) {
    // Same option 1, first available variant
    const matchOption1Available = product.variants.find(v =>
      v.options[0] === computedSelected[0] && v.available
    );
    if (matchOption1Available) return matchOption1Available;

    // Same option 1, any variant (sold out but exists)
    const matchOption1Any = product.variants.find(v =>
      v.options[0] === computedSelected[0]
    );
    if (matchOption1Any) return matchOption1Any;

    // Any available variant
    return product.variants.find(v => v.available) || product.variants[0];
  }

  document.querySelectorAll('variant-selection').forEach(vs => {
    vs.addEventListener('variant-change', e => {
      const { product, variant, state } = e.detail;
      if (!product) return;

      // state is 'unavailable' when options are selected but no variant matches
      if (state !== 'unavailable') return;

      const os = vs.querySelector('options-selection');
      if (!os) return;

      const computedSelected = product.options.map((_, i) => {
        const checked = os.querySelector(
          `input[type="radio"][data-variant-option-value-index="${i}"]:checked`
        );
        return checked ? checked.value : null;
      });

      const nearest = findNearestVariant(product, computedSelected);
      if (!nearest) return;

      // Update radio inputs to match nearest variant
      nearest.options.forEach((value, i) => {
        const input = os.querySelector(
          `input[type="radio"][data-variant-option-value-index="${i}"][value="${CSS.escape(value)}"]`
        );
        if (input && !input.checked) {
          input.checked = true;
          // Dispatch a real change event so the original machinery picks it up
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
  });

  OptionsSelection.prototype._updateOptions = function(disableUnavailableOptions, removeUnavailableOptions, selectedOptions = null) {
    return originalUpdateOptions.call(this, disableUnavailableOptions, removeUnavailableOptions, selectedOptions)
      .then(() => {
        if (!removeUnavailableOptions || !this._variantSelection) return;

        return this._variantSelection.getProduct().then(product => {
          if (!product) return;

          const computedSelected = selectedOptions || product.options.map((_, i) => {
            const checked = this.querySelector(`input[type="radio"][data-variant-option-value-index="${i}"]:checked`);
            return checked ? checked.value : null;
          });

          this._radioOptions.forEach(({ wrappers, values }) => {
            values.forEach((input, j) => {
              const optionIndex = parseInt(input.dataset.variantOptionValueIndex, 10);

              let exists;

              if (optionIndex === 0) {
                exists = product.variants.some(v => v.options[0] === input.value);
              } else if (optionIndex === 1) {
                exists = product.variants.some(v =>
                  v.options[0] === computedSelected[0] &&
                  v.options[1] === input.value
                );
              } else if (optionIndex === 2) {
                exists = product.variants.some(v =>
                  v.options[0] === computedSelected[0] &&
                  v.options[1] === computedSelected[1] &&
                  v.options[2] === input.value
                );
              }

              if (!exists) {
                const wrapper = wrappers[j];
                if (wrapper && wrapper.parentNode) {
                  wrapper.parentNode.removeChild(wrapper);
                }
              }
            });
          });
        });
      });
  };
});

// Keep the "Inventory level" product block in sync with the selected variant.
// `variant-change` is dispatched on <variant-selection> and doesn't bubble, so listen during the
// capture phase on document. That also covers product forms added to the page later (e.g. quick shop).
document.addEventListener('variant-change', event => {
  const { variant } = event.detail;
  const productDetails = event.target.closest('[data-product-details]');
  if (!productDetails) return;

  productDetails.querySelectorAll('[data-inventory-level]').forEach(el => {
    // Variants that don't track inventory are missing from the map; so is a variant that isn't selected
    const text = variant ? JSON.parse(el.dataset.inventoryTexts)[variant.id] : undefined;

    if (text === undefined) {
      el.hidden = true;
      return;
    }

    el.textContent = text;
    el.hidden = false;
  });
}, true);
